export default "__VITE_ASSET__B6Y9XXej__"